<template>
    <grant-sub-wizard>
        <grant-sub-wizard-tab>
            <form>
                <div class="row mt-3">
                    <div class="col-lg-9 count-titles">
                        <h3>{{ $t('proposals.section_title__main_applicant') }}</h3>
                        <!-- Organisation legal name -->
                        <h4 class="card-title">{{ $t('proposals.field_title__organisation_legal_name') }}</h4>
                        <div class="form-group">
                            <textarea
                                class="form-control"
                                name="fp_applicant.organisation_legal_name"
                                v-model="CallForm.model.fp_applicant.organisation_legal_name"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__organisation_legal_name')"
                                :label="$t('proposals.field_title__organisation_legal_name')"
                                :error="getError('fp_applicant.organisation_legal_name')"
                                :placeholder="$t('general.general__insert_here')"
                                >
                            </textarea>
                            <label v-if="getError('fp_applicant.organisation_legal_name')" class="error text-danger">{{ getError('fp_applicant.organisation_legal_name') }}</label>
                        </div>

                        <!-- Common name of the organisation/acronym -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__organisation_common_name') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__organisation_common_name') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <textarea
                                class="form-control"
                                name="fp_applicant.organisation_common_name"
                                v-model="CallForm.model.fp_applicant.organisation_common_name"
                                :disabled="!CallForm.isFPEditable"
                                :label="$t('proposals.field_title__organisation_common_name')"
                                :placeholder="$t('general.general__insert_here')"
                                >
                            </textarea>
                        </div>

                        <!-- Address -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__address') }}
                        </h4>
                        <div class="form-group">
                            <textarea
                                class="form-control"
                                name="fp_applicant.address"
                                v-model="CallForm.model.fp_applicant.address"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__address')"
                                :label="$t('proposals.field_title__address')"
                                :error="getError('fp_applicant.address')"
                                :placeholder="$t('general.general__insert_here')"
                                >
                            </textarea>
                            <label v-if="getError('fp_applicant.address')" class="error text-danger">{{ getError('fp_applicant.address') }}</label>
                        </div>

                        <!-- Website -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__website') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__website') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <textarea
                                class="form-control"
                                name="fp_applicant.website"
                                v-model="CallForm.model.fp_applicant.website"
                                :disabled="!CallForm.isFPEditable"
                                :label="$t('proposals.field_title__website')"
                                :placeholder="$t('general.general__insert_here')"
                                >
                            </textarea>
                        </div>

                        <!-- Project leader contact details -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__project_leader_contact_details') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__project_leader_contact_details') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <table class="mt-3 mb-2 table-bordered" width="100%">
                                <tbody>
                                    <tr>
                                        <td>{{ $t('proposals.field_title__name_surname') }}</td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="fp_applicant.project_leader_name"
                                                v-model="CallForm.model.fp_applicant.project_leader_name"
                                                v-validate.persist="'required'"
                                                :disabled="!CallForm.isFPEditable"
                                                :data-vv-as="$t('proposals.field_title__name_surname')"
                                                />
                                            <label v-if="getError('fp_applicant.project_leader_name')" class="error text-danger">{{ getError('fp_applicant.project_leader_name') }}</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('proposals.field_title__job_title') }}</td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="fp_applicant.project_leader_job_title"
                                                v-model="CallForm.model.fp_applicant.project_leader_job_title"
                                                v-validate.persist="'required'"
                                                :disabled="!CallForm.isFPEditable"
                                                :data-vv-as="$t('proposals.field_title__job_title')"
                                                />
                                            <label v-if="getError('fp_applicant.project_leader_job_title')" class="error text-danger">{{ getError('fp_applicant.project_leader_job_title') }}</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('proposals.field_title__email') }}</td>
                                        <td>
                                            <input
                                                type="email"
                                                class="form-control"
                                                name="fp_applicant.project_leader_email"
                                                v-model="CallForm.model.fp_applicant.project_leader_email"
                                                v-validate.persist="'required'"
                                                :disabled="!CallForm.isFPEditable"
                                                :data-vv-as="$t('proposals.field_title__email')"
                                                />
                                            <label v-if="getError('fp_applicant.project_leader_email')" class="error text-danger">{{ getError('fp_applicant.project_leader_email') }}</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('proposals.field_title__phone') }}</td>
                                        <td>
                                            <input
                                                type="phone"
                                                class="form-control"
                                                name="fp_applicant.project_leader_phone"
                                                v-model="CallForm.model.fp_applicant.project_leader_phone"
                                                v-validate.persist="{ required: true, regex: /[0-9\+.,\(\)]+/ }"
                                                :disabled="!CallForm.isFPEditable"
                                                :data-vv-as="$t('proposals.field_title__phone')"
                                                />
                                            <label v-if="getError('fp_applicant.project_leader_phone')" class="error text-danger">The Phone field must be a valid phone number</label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Authorised signatory -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__authorised_signatory') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__authorised_signatory') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <table class="mt-3 mb-2 table-bordered" width="100%">
                                <tbody>
                                    <tr>
                                        <td>{{ $t('proposals.field_title__name_surname') }}</td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="fp_applicant.authorised_signatory_name"
                                                v-model="CallForm.model.fp_applicant.authorised_signatory_name"
                                                :disabled="!CallForm.isFPEditable"
                                                />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('proposals.field_title__job_title') }}</td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="fp_applicant.authorised_signatory_job_title"
                                                v-model="CallForm.model.fp_applicant.authorised_signatory_job_title"
                                                :disabled="!CallForm.isFPEditable"
                                                />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('proposals.field_title__email') }}</td>
                                        <td>
                                            <input
                                                type="email"
                                                class="form-control"
                                                name="fp_applicant.authorised_signatory_email"
                                                v-model="CallForm.model.fp_applicant.authorised_signatory_email"
                                                :disabled="!CallForm.isFPEditable"
                                                />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('proposals.field_title__phone') }}</td>
                                        <td>
                                            <input
                                                type="phone"
                                                class="form-control"
                                                name="fp_applicant.authorised_signatory_phone"
                                                v-model="CallForm.model.fp_applicant.authorised_signatory_phone"
                                                :disabled="!CallForm.isFPEditable"
                                                />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Type of organisation -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__type_of_organisation') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__type_of_organisation') }}</span>
                            </i>
                        </h4>
                        <div class="mt-3">
                            <radio
                                name="fp_applicant.type_of_organisation"
                                value="1"
                                v-model="CallForm.model.fp_applicant.type_of_organisation"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                            >
                                <label>{{ $t('proposals.field_title__type_of_organisation_type_01') }}</label>
                            </radio>
                            <radio
                                name="fp_applicant.type_of_organisation"
                                value="2"
                                v-model="CallForm.model.fp_applicant.type_of_organisation"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                            >
                                <label>{{ $t('proposals.field_title__type_of_organisation_type_02') }}</label>
                            </radio>
                            <radio
                                name="fp_applicant.type_of_organisation"
                                value="3"
                                v-model="CallForm.model.fp_applicant.type_of_organisation"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                            >
                                <label>{{ $t('proposals.field_title__type_of_organisation_type_03') }}</label>
                            </radio>
                            <radio
                                name="fp_applicant.type_of_organisation"
                                value="4"
                                v-model="CallForm.model.fp_applicant.type_of_organisation"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                            >
                                <label>{{ $t('proposals.field_title__type_of_organisation_type_04') }}</label>
                            </radio>
                            <radio
                                name="fp_applicant.type_of_organisation"
                                value="5"
                                v-model="CallForm.model.fp_applicant.type_of_organisation"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                            >
                                <label>{{ $t('proposals.field_title__type_of_organisation_type_05') }}</label>
                            </radio>
                        </div>
                        <label v-if="getError('fp_applicant.type_of_organisation')" class="error text-danger">{{ getError('fp_applicant.type_of_organisation') }}</label>

                        <!-- Presentation of your organisation -->
                        <h4 class="card-title mb-0">
                            {{ $t('proposals.field_title__organisation_presentation') }}
                        </h4>
                        <p>{{ $t('stage_two.general_words_remaining', {words: applicant_organisation_and_role_presentation_count}) }}</p>
                        <div class="form-group">
                            <textarea
                                class="form-control"
                                name="fp_applicant.organisation_and_role_presentation"
                                maxwords="250"
                                v-wordscount="applicant_organisation_and_role_presentation_count"
                                v-model="CallForm.model.fp_applicant.organisation_and_role_presentation"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__organisation_presentation')"
                                :label="$t('proposals.field_title__organisation_presentation')"
                                :error="getError('fp_applicant.organisation_and_role_presentation')"
                                :placeholder="$t('general.general__insert_here')"
                                >
                            </textarea>
                            <label v-if="getError('fp_applicant.organisation_and_role_presentation')" class="error text-danger">{{ getError('fp_applicant.organisation_and_role_presentation') }}</label>
                        </div>

                        <!-- Applicant(s) capacities -->
                        <h4 class="card-title mb-0">
                            {{ $t('proposals.field_title__applicant_capacities') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__applicant_co_applicant_capacities') }}</span>
                            </i>
                        </h4>
                        <p>{{ $t('stage_two.general_words_remaining', {words: applicants_capacities_count}) }}</p>
                        <div class="form-group">
                            <textarea
                                class="form-control"
                                name="fp_applicant.applicants_capacities"
                                maxwords="400"
                                v-wordscount="applicants_capacities_count"
                                v-model="CallForm.model.fp_applicant.applicants_capacities"
                                v-validate.persist="'required'"
                                :data-vv-as="$t('proposals.field_title__applicant_co_applicant_capacities')"
                                :disabled="!CallForm.isFPEditable"
                                :label="$t('proposals.field_title__applicant_co_applicant_capacities')"
                                :placeholder="$t('general.general__insert_here')"
                                >
                            </textarea>
                            <label v-if="getError('fp_applicant.applicants_capacities')" class="error text-danger">{{ getError('fp_applicant.applicants_capacities') }}</label>
                        </div>

                        <br />
                        <br />

                        <h3>{{ $t('proposals.section_title__co_applicant') }}</h3>

                        <!-- Is there any co-applicant -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__is_there_any_co_applicant') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__is_there_any_co_applicant') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <radio
                                name="fp_applicant.has_co_applicant"
                                class="form-check-inline"
                                value="YES"
                                v-model="CallForm.model.fp_applicant.has_co_applicant"
                                v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__is_there_any_co_applicant')"
                                >
                                <label>{{ $t('stage_two.general_yes') }}</label>
                            </radio>
                            <radio
                                name="fp_applicant.has_co_applicant"
                                class="form-check-inline"
                                value="NO"
                                v-model="CallForm.model.fp_applicant.has_co_applicant"
                                v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__is_there_any_co_applicant')"
                                >
                                <label>{{ $t('stage_two.general_no') }}</label>
                            </radio>
                            <label v-if="getError('fp_applicant.has_co_applicant')" class="error text-danger">{{ getError('fp_applicant.has_co_applicant') }}</label>
                        </div>

                        <!-- Co-applicant -->
                        <!-- <h4 class="card-title">
                            {{ $t('proposals.field_title__co_applicant') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__co_applicant') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <textarea
                                class="form-control"
                                name="fp_applicant.co_applicant"
                                v-model="CallForm.model.fp_applicant.co_applicant"
                                v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                :data-vv-as="$t('proposals.field_title__co_applicant')"
                                :disabled="!CallForm.isFPEditable"
                                :label="$t('proposals.field_title__co_applicant')"
                                :placeholder="$t('general.general__insert_here')"
                                >
                            </textarea>
                            <label v-if="getError('fp_applicant.co_applicant')" class="error text-danger">{{ getError('fp_applicant.co_applicant') }}</label>
                        </div> -->

                        <div v-if="CallForm.model.fp_applicant.has_co_applicant === 'YES'">
                            <br />
                            <br />
                            <br />
                            <br />

                            <!-- Co-applicant: Organisation legal name -->
                            <h4 class="card-title">{{ $t('proposals.field_title__organisation_legal_name') }}</h4>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    name="fp_applicant.co_applicant_organisation_legal_name"
                                    v-model="CallForm.model.fp_applicant.co_applicant_organisation_legal_name"
                                    v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                    :data-vv-as="$t('proposals.field_title__organisation_legal_name')"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__organisation_legal_name')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                                <label v-if="getError('fp_applicant.co_applicant_organisation_legal_name')" class="error text-danger">{{ getError('fp_applicant.co_applicant_organisation_legal_name') }}</label>
                            </div>

                            <!-- Co-applicant: Type of organisation -->
                            <h4 class="card-title">
                                {{ $t('proposals.field_title__type_of_organisation') }}
                                <i class="fa fa-question">
                                    <span>{{ $t('proposals.field_info__co_applicant_type_of_organisation') }}</span>
                                </i>
                            </h4>
                            <div class="mt-3">
                                <radio
                                    name="fp_applicant.co_applicant_type_of_organisation"
                                    value="1"
                                    v-model="CallForm.model.fp_applicant.co_applicant_type_of_organisation"
                                    v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                    :data-vv-as="$t('proposals.field_title__organisation_legal_name')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_01') }}</label>
                                </radio>
                                <radio
                                    name="fp_applicant.co_applicant_type_of_organisation"
                                    value="2"
                                    v-model="CallForm.model.fp_applicant.co_applicant_type_of_organisation"
                                    v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                    :data-vv-as="$t('proposals.field_title__organisation_legal_name')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_02') }}</label>
                                </radio>
                                <radio
                                    name="fp_applicant.co_applicant_type_of_organisation"
                                    value="3"
                                    v-model="CallForm.model.fp_applicant.co_applicant_type_of_organisation"
                                    v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                    :data-vv-as="$t('proposals.field_title__organisation_legal_name')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_03') }}</label>
                                </radio>
                                <radio
                                    name="fp_applicant.co_applicant_type_of_organisation"
                                    value="4"
                                    v-model="CallForm.model.fp_applicant.co_applicant_type_of_organisation"
                                    v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                    :data-vv-as="$t('proposals.field_title__organisation_legal_name')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_04') }}</label>
                                </radio>
                                <radio
                                    name="fp_applicant.co_applicant_type_of_organisation"
                                    value="5"
                                    v-model="CallForm.model.fp_applicant.co_applicant_type_of_organisation"
                                    v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                    :data-vv-as="$t('proposals.field_title__organisation_legal_name')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_05') }}</label>
                                </radio>
                                <label v-if="getError('fp_applicant.co_applicant_type_of_organisation')" class="error text-danger">{{ getError('fp_applicant.co_applicant_type_of_organisation') }}</label>
                            </div>

                            <!-- Co-applicant: Presentation of your organisation -->
                            <h4 class="card-title mb-0">
                                {{ $t('proposals.field_title__organisation_presentation') }}
                            </h4>
                            <p>{{ $t('stage_two.general_words_remaining', {words: co_applicant_organisation_and_role_presentation_count}) }}</p>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    name="fp_applicant.co_applicant_organisation_and_role_presentation"
                                    maxwords="200"
                                    v-wordscount="co_applicant_organisation_and_role_presentation_count"
                                    v-model="CallForm.model.fp_applicant.co_applicant_organisation_and_role_presentation"
                                    v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                    :data-vv-as="$t('proposals.field_title__organisation_presentation')"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__organisation_presentation')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                                <label v-if="getError('fp_applicant.co_applicant_organisation_and_role_presentation')" class="error text-danger">{{ getError('fp_applicant.co_applicant_organisation_and_role_presentation') }}</label>
                            </div>

                            <!-- Co-applicant(s) capacities -->
                            <h4 class="card-title mb-0">
                                {{ $t('proposals.field_title__applicant_co_applicant_capacities') }}
                                <i class="fa fa-question">
                                    <span>{{ $t('proposals.field_info__applicant_co_applicant_capacities') }}</span>
                                </i>
                            </h4>
                            <p>{{ $t('stage_two.general_words_remaining', {words: applicants_and_co_applicants_capacities_count}) }}</p>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    name="fp_applicant.applicants_and_co_applicants_capacities"
                                    maxwords="400"
                                    v-wordscount="applicants_and_co_applicants_capacities_count"
                                    v-model="CallForm.model.fp_applicant.applicants_and_co_applicants_capacities"
                                    v-validate.persist="CallForm.model.fp_applicant.has_co_applicant === 'YES' ? 'required' : ''"
                                    :data-vv-as="$t('proposals.field_title__applicant_co_applicant_capacities')"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__applicant_co_applicant_capacities')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                                <label v-if="getError('fp_applicant.applicants_and_co_applicants_capacities')" class="error text-danger">{{ getError('fp_applicant.applicants_and_co_applicants_capacities') }}</label>
                            </div>
                        </div>

                        <div
                            v-if="CallForm.model.fp_applicant.has_co_applicant === 'YES'"
                            v-for="(item, index) in CallForm.model.fp_applicant.co_applicants"
                            >
                            <h4 class="mt-4" style="display: inline-block">{{ $t('proposals.field_title__co_applicant') + ' ' + (index + 2) }}</h4>
                            <span class="coapp-remove-item tim-icons icon-trash-simple" v-if="CallForm.isFPEditable" @click="removeCoApplicant(index)"></span>
                            <!-- Co-applicant: Organisation legal name -->
                            <h4 class="card-title">{{ $t('proposals.field_title__organisation_legal_name') }}</h4>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    :name="'fp_applicant.co_applicant_' + (index + 1) + '_organisation_legal_name'"
                                    v-model="item.organisation_legal_name"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__organisation_legal_name')"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__organisation_legal_name')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                                <label v-if="getError('fp_applicant.co_applicant_' + (index + 1) + '_organisation_legal_name')" class="error text-danger">{{ getError('fp_applicant.co_applicant_' + (index + 1) + '_organisation_legal_name') }}</label>
                            </div>

                            <!-- Co-applicant: Type of organisation -->
                            <h4 class="card-title">
                                {{ $t('proposals.field_title__type_of_organisation') }}
                                <i class="fa fa-question">
                                    <span>{{ $t('proposals.field_info__co_applicant_type_of_organisation') }}</span>
                                </i>
                            </h4>
                            <div class="mt-3">
                                <radio
                                    :name="'fp_applicant.co_applicant_' + (index + 1) + '_type_of_organisation'"
                                    value="1"
                                    v-model="item.type_of_organisation"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_01') }}</label>
                                </radio>
                                <radio
                                    :name="'fp_applicant.co_applicant_' + (index + 1) + '_type_of_organisation'"
                                    value="2"
                                    v-model="item.type_of_organisation"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_02') }}</label>
                                </radio>
                                <radio
                                    :name="'fp_applicant.co_applicant_' + (index + 1) + '_type_of_organisation'"
                                    value="3"
                                    v-model="item.type_of_organisation"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_03') }}</label>
                                </radio>
                                <radio
                                    :name="'fp_applicant.co_applicant_' + (index + 1) + '_type_of_organisation'"
                                    value="4"
                                    v-model="item.type_of_organisation"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_04') }}</label>
                                </radio>
                                <radio
                                    :name="'fp_applicant.co_applicant_' + (index + 1) + '_type_of_organisation'"
                                    value="5"
                                    v-model="item.type_of_organisation"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__type_of_organisation')"
                                    :disabled="!CallForm.isFPEditable"
                                >
                                    <label>{{ $t('proposals.field_title__type_of_organisation_type_05') }}</label>
                                </radio>
                                <label v-if="getError('fp_applicant.co_applicant_' + (index + 1) + '_type_of_organisation')" class="error text-danger">{{ getError('fp_applicant.co_applicant_' + (index + 1) + '_type_of_organisation') }}</label>
                            </div>

                            <!-- Co-applicant: Presentation of your organisation -->
                            <h4 class="card-title mb-0">
                                {{ $t('proposals.field_title__organisation_presentation') }}
                            </h4>
                            <p>{{ $t('stage_two.general_words_remaining', {words: co_applicant_organisation_and_role_presentation_count}) }}</p>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    :name="'fp_applicant.co_applicant_' + (index + 1) + '_organisation_and_role_presentation'"
                                    maxwords="200"
                                    v-wordscount="co_applicant_organisation_and_role_presentation_count"
                                    v-model="item.organisation_and_role_presentation"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__organisation_presentation')"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__organisation_presentation')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                                <label v-if="getError('fp_applicant.co_applicant_' + (index + 1) + '_organisation_and_role_presentation')" class="error text-danger">{{ getError('fp_applicant.co_applicant_' + (index + 1) + '_organisation_and_role_presentation') }}</label>
                            </div>

                            <!-- Co-applicant(s) capacities -->
                            <h4 class="card-title mb-0">
                                {{ $t('proposals.field_title__applicant_co_applicant_capacities') }}
                                <i class="fa fa-question">
                                    <span>{{ $t('proposals.field_info__applicant_co_applicant_capacities') }}</span>
                                </i>
                            </h4>
                            <p>{{ $t('stage_two.general_words_remaining', {words: applicants_and_co_applicants_capacities_count}) }}</p>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    :name="'fp_applicant.co_applicant_' + (index + 1) + '_capacities'"
                                    maxwords="400"
                                    v-wordscount="applicants_and_co_applicants_capacities_count"
                                    v-model="item.co_applicants_capacities"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__applicant_co_applicant_capacities')"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__applicant_co_applicant_capacities')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                                <label v-if="getError('fp_applicant.co_applicant_' + (index + 1) + '_capacities')" class="error text-danger">{{ getError('fp_applicant.co_applicant_' + (index + 1) + '_capacities') }}</label>
                            </div>
                        </div>

                        <base-button
                            v-if="CallForm.isFPEditable && CallForm.model.fp_applicant.has_co_applicant === 'YES'"
                            type="primary"
                            size="lg"
                            class="btn-fill btn-add-new-document"
                            @click.native="addCoApplicant()"
                            >
                            {{ $t('proposals.button_title__add_co_applicant') }}
                        </base-button>

                        <br />
                        <br />
                        <br />
                        <br />

                        <h3>{{ $t('proposals.section_title__other_projects') }}</h3>

                        <!-- Are your organisation and/or your co-applicant(s)... -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__involved_in_other_projects') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__involved_in_other_projects') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <radio
                                name="fp_applicant.involved_in_other_proects"
                                class="form-check-inline"
                                value="YES"
                                v-model="CallForm.model.fp_applicant.involved_in_other_proects"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__involved_in_other_projects')"
                                >
                                <label>{{ $t('stage_two.general_yes') }}</label>
                            </radio>
                            <radio
                                name="fp_applicant.involved_in_other_proects"
                                class="form-check-inline"
                                value="NO"
                                v-model="CallForm.model.fp_applicant.involved_in_other_proects"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__involved_in_other_projects')"
                                >
                                <label>{{ $t('stage_two.general_no') }}</label>
                            </radio>
                            <label v-if="getError('fp_applicant.involved_in_other_proects')" class="error text-danger">{{ getError('fp_applicant.involved_in_other_proects') }}</label>
                        </div>

                        <!-- Project title and reference -->
                        <div v-if="CallForm.model.fp_applicant.involved_in_other_proects === 'YES'">
                            <h4 class="card-title">
                                {{ $t('proposals.field_title__project_title_and_reference') }}
                            </h4>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    name="fp_applicant.involved_in_other_proects_project_title_and_reference"
                                    v-model="CallForm.model.fp_applicant.involved_in_other_proects_project_title_and_reference"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__project_title_and_reference')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                            </div>
                        </div>

                        <!-- Did your organisation and/or your co-applicant(s) already benefit from a BEST grant as lead or co-applicant? -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__already_benefit_from_a_grant') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__already_benefit_from_a_grant') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <radio
                                name="fp_applicant.already_benefit_from_a_grant"
                                class="form-check-inline"
                                value="YES"
                                v-model="CallForm.model.fp_applicant.already_benefit_from_a_grant"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__already_benefit_from_a_grant')"
                                >
                                <label>{{ $t('stage_two.general_yes') }}</label>
                            </radio>
                            <radio
                                name="fp_applicant.already_benefit_from_a_grant"
                                class="form-check-inline"
                                value="NO"
                                v-model="CallForm.model.fp_applicant.already_benefit_from_a_grant"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__already_benefit_from_a_grant')"
                                >
                                <label>{{ $t('stage_two.general_no') }}</label>
                            </radio>
                            <label v-if="getError('fp_applicant.already_benefit_from_a_grant')" class="error text-danger">{{ getError('fp_applicant.already_benefit_from_a_grant') }}</label>
                        </div>

                        <!-- Project title and reference -->
                        <div v-if="CallForm.model.fp_applicant.already_benefit_from_a_grant === 'YES'">
                            <h4 class="card-title">
                                {{ $t('proposals.field_title__project_title_and_reference') }}
                            </h4>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    name="fp_applicant.already_benefit_from_a_grant_project_title_and_reference"
                                    v-model="CallForm.model.fp_applicant.already_benefit_from_a_grant_project_title_and_reference"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__project_title_and_reference')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                            </div>
                        </div>

                        <!-- Did your organisation and/or your co-applicant(s) already benefit from a European funding? (LIFE, INTERREG, etc.) -->
                        <h4 class="card-title">
                            {{ $t('proposals.field_title__already_benefit_from_a_funding') }}
                            <i class="fa fa-question">
                                <span>{{ $t('proposals.field_info__already_benefit_from_a_grant') }}</span>
                            </i>
                        </h4>
                        <div class="form-group">
                            <radio
                                name="fp_applicant.already_benefit_from_a_eu_funding"
                                class="form-check-inline"
                                value="YES"
                                v-model="CallForm.model.fp_applicant.already_benefit_from_a_eu_funding"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__already_benefit_from_a_funding')"
                                >
                                <label>{{ $t('stage_two.general_yes') }}</label>
                            </radio>
                            <radio
                                name="fp_applicant.already_benefit_from_a_eu_funding"
                                class="form-check-inline"
                                value="NO"
                                v-model="CallForm.model.fp_applicant.already_benefit_from_a_eu_funding"
                                v-validate.persist="'required'"
                                :disabled="!CallForm.isFPEditable"
                                :data-vv-as="$t('proposals.field_title__already_benefit_from_a_funding')"
                                >
                                <label>{{ $t('stage_two.general_no') }}</label>
                            </radio>
                            <label v-if="getError('fp_applicant.already_benefit_from_a_eu_funding')" class="error text-danger">{{ getError('fp_applicant.already_benefit_from_a_eu_funding') }}</label>
                        </div>

                        <!-- Project title and reference -->
                        <div v-if="CallForm.model.fp_applicant.already_benefit_from_a_eu_funding === 'YES'">
                            <h4 class="card-title">
                                {{ $t('proposals.field_title__project_title_and_reference') }}
                            </h4>
                            <div class="form-group">
                                <textarea
                                    class="form-control"
                                    name="fp_applicant.already_benefit_from_a_grant_project_title_and_reference"
                                    v-model="CallForm.model.fp_applicant.already_benefit_from_a_eu_funding_project_title_and_reference"
                                    :disabled="!CallForm.isFPEditable"
                                    :label="$t('proposals.field_title__project_title_and_reference')"
                                    :placeholder="$t('general.general__insert_here')"
                                    >
                                </textarea>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </grant-sub-wizard-tab>
    </grant-sub-wizard>
</template>
<script>
import Multiselect from 'vue-multiselect';
import { CallForm } from "@/services";
import {GrantSubWizard, GrantSubWizardTab} from '@/components';

export default
{
    components:
    {
        Multiselect,
        GrantSubWizard,
        GrantSubWizardTab,
    },
    data()
    {
        return {
            CallForm,
            applicant_organisation_and_role_presentation_count: 250,
            co_applicant_organisation_and_role_presentation_count: 200,
            applicants_and_co_applicants_capacities_count: 400,
            applicants_capacities_count: 400,
        }
    },
    methods:
    {
        getError(fieldName)
        {
            return this.errors.first(fieldName);
        },
        validate()
        {
            return this.$validator.validateAll().then(res => {
                this.$emit('on-validated', res, this.model);
                return res;
            });
        },
        addCoApplicant()
        {
            if (!CallForm.model.fp_applicant.co_applicants)
            {
                CallForm.model.fp_applicant.co_applicants = [];
            }

            CallForm.model.fp_applicant.co_applicants.push({
            });

            this.$forceUpdate();
        },
        removeCoApplicant(index)
        {
            if (confirm(this.$t('proposals.confirm__remove_co_applicant')))
            {
                CallForm.model.fp_applicant.co_applicants.splice(index, 1);

                this.$forceUpdate();
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    a
    {
        color: black;

        &:hover
        {
            text-decoration: underline;
        }
    }

    .count-titles
    {
        counter-reset: cardTitles;

        h4.card-title
        {
            margin-top: 10px;
            counter-increment: cardTitles;

            &:before
            {
                content: counter(cardTitles) '. ';
            }

            .fa-question
            {
                margin-left: 10px;
                display: inline-block;
                width: 24px;
                height: 24px;
                font-size: 13px;
                line-height: 24px;
                text-align: center;
                color: #fff;
                border-radius: 100%;
                background-color: #2083f7;
            }
        }
    }

    .table-bordered th,
    .table-bordered td
    {
        padding: 5px;
    }

    .card-wizard .disabled
    {
        display: block;
    }

    .coapp-remove-item
    {
        margin-left: 15px;
        display: inline-block;
        cursor: pointer;

        &:hover
        {
            color: #f00;
        }
    }
</style>
